import React from 'react'
import { I18n } from '@front/volcanion/'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'
import CompanyTab from '@abra/panels/Tab/Company'
import OrderLimitationSection from '@abra/panels/OrderLimitation'

import FormSpeedDial from '@abra/elements/speedDial/Form'
import PrimarySection from './Section/Primary'
import CompanyInfoSection from './Section/CompanyInfo'
import ServicesSection from './Section/Services'
import Popups from './Popup'


const CompanyUser = ({ handleClickClientDetail, openSendIdentifierDialog, company, showIdentifierAction }) => {

  const actions = [
    { name: I18n.t('user.label', { count: 1 }), iconName: 'account_circle', onClick: handleClickClientDetail },
    { name: I18n.t('companyuser.actions.identifier'), iconName: 'email', onClick: openSendIdentifierDialog, hidden: !showIdentifierAction },
  ]

  return (
    <>
      <Popups />
      <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
        <Grid container rowSpacing={3}>
          <Grid size={12}><CompanyTab value={3} /></Grid>
          <Grid size={12}><FormHeader disabledButton goBackPath={`/company/${company}/user`} /></Grid>
          <Grid size={12}>
            <GridStepper groupsCount={[4]} activeStep={0} orientation="vertical">
              <Step>
                <PrimarySection />
              </Step>
              <Step>
                <CompanyInfoSection />
              </Step>
              <Step> <OrderLimitationSection model='companyorderlimit' company={company} /> </Step>
              <Step>
                <ServicesSection />
              </Step>
            </GridStepper>
          </Grid>
        </Grid>
      </Box>
      <FormSpeedDial actions={actions} />
    </>
  );
}

export default React.memo(CompanyUser)
